import { createContext } from "react";
import { Breakpoint, breakpointsConfig } from "../CustomHooks/useBreakpoint";

export const BreakpointContext = createContext<Breakpoint>(breakpointsConfig[0]);